import mic from "./images/onairmicrophone.svg";
import logo from "./images/newhoremowghradioicon.png";
import { useContext, useEffect, useMemo, useState } from "react";
import { realtimeDB } from "./Backend";
import format from "date-fns/format";
import { get, off, onValue, ref, set } from "firebase/database";
import { HbrArrowLeft, HbrShareIcon } from "./MyCustomsvgicons";
import { useLocation, useNavigate } from "react-router-dom";
import CommentCollection from "./CommentCollection";
import InputComments from "./InputComment";
import ShareForm from "./newComponent/shareForm";
import UseLayout from "./UseLayout";
import { appVariables, sanitizeText } from "./utilityClass";
import { DataContext } from "./DataContextProvider";
import { SocketIO } from "./webRtc/SocketIo";




const OnlineRadio = () => {
  const {userName} = useContext(DataContext);
  const {userID} = useContext(DataContext);
  const {userLocation} = useContext(DataContext);
  const [startRadioBroadcast,setRadio]=useState(false);
  const [name,setName] = useState("");
  const [user_id,setUserID] = useState("");
  const [unitLocation,setUnitLocation] = useState(userLocation);
  const [numofusers,setNumofusers]=useState([]);
  const [programTitle, setProgramTitle] = useState("");
  const today = new Date();
  const formattOday = format(today,"yyyy-MM-dd");
  const [isLoading,setIsLoading]=useState(false);
  const [showShare, setShowShare] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const roomid = "hghradioroom";
  const {width} = UseLayout();

      useEffect(()=>{
          const radioParticipantsRef = ref(realtimeDB, `socket${roomid}`);
          const programTitleRef = ref(realtimeDB, `radio-program`);

          const getProgramTitle=async()=>{
            const programTitlesnapshot = await get(ref(realtimeDB, `radio-program`));
            if (programTitlesnapshot.exists()) {
              setProgramTitle(programTitlesnapshot.val());
            }
          }
          getProgramTitle();
                
          const programTitleListener = onValue(programTitleRef, (snapshot)=>{
            if (snapshot.exists()) {
              setProgramTitle(snapshot.val());
            }
          });

          const radioListener = onValue(radioParticipantsRef, (snapshot)=>{
            if (snapshot.exists()) {
                const usersData = snapshot.val();
                const usersArray = Object.keys(usersData).map((key) =>({
                    id: key,
                    ...usersData[key]
                }));
                setNumofusers(usersArray);
            }
          });
        
          // const bethelListener = onValue(bethelViewersRef, (snapshot)=>{
          //     if (snapshot.exists()) {
          //         const usersData = snapshot.val();
          //         const usersArray = Object.keys(usersData).map((key) =>({
          //             id: key,
          //             ...usersData[key]
          //         }));
          //         setNumofviewers(usersArray);
          //     }
          // });

          const userName = localStorage.getItem("name_id");
          const user_location = localStorage.getItem("location_id");
          const getUserID = localStorage.getItem("user_id");
          if(userName){
            setName(userName);
          };
          if(user_location){
            setUnitLocation(user_location);
          }
          if(getUserID){
            setUserID(getUserID);
          }

          
  
          return()=>{
            // off(bethelViewersRef, bethelListener);
            off(radioParticipantsRef, "value" ,radioListener);
            off(programTitleRef, "value" ,programTitleListener);
          }
      },[]);
      // const memoizedViewers = useMemo(()=>numofviewers,[numofviewers]);
      const memoizedRadioUsers = useMemo(()=>numofusers,[numofusers]);


  const handleSubmit = async (e)=>{
    e.preventDefault();
    setIsLoading(true);
    try {
      set(ref(realtimeDB,`users/${sanitizeText(user_id)}`),{
        name,
        dateJoined: formattOday
      });
      setIsLoading(false);
      setRadio(true);
      localStorage.setItem("user_id",user_id);
      localStorage.setItem("name_id",name);
      localStorage.setItem("location_id",unitLocation);
      SocketIO.emit("horemowgh_socket", {roomid, userName, userPicture:"", userid: userID, unitloc: unitLocation});
    } catch (error) {
      alert("sorry we are unable to connect you now, try again later");
      setIsLoading(false);
    }
  };

  useEffect(()=>{
        const getExistingUser=()=>{
            if (!userName || !userID || !userLocation) {
              setRadio(false);
            }else{
              setRadio(true);
              try {
                set(ref(realtimeDB,`users/${sanitizeText(userID)}`),{
                  userName,
                  dateJoined: formattOday
                });
                SocketIO.emit("horemowgh_socket", {roomid, userName, userPicture:"", userid: userID, unitloc: unitLocation});
                
              } catch (err){
                console.log(err)
              }
            }
          }

          getExistingUser();
  },[formattOday, userName, userID, userLocation, unitLocation]);

  const disConnectRadio=()=>{
    SocketIO.emit("auto_disconnect", {roomid, userid: userID});
    if (location.state && location.state.from) {
      navigate(location.state.from);
    }else{
        navigate("/");
    }
  }


    return startRadioBroadcast ?(
  
             <div className="gh-radio">
             <div className="radio-feed">
                 <iframe id="radio-frame" src="https://stream-153.zeno.fm/pk9fdstgtp8uv?zs=tkEMguoMQR2qBXltHHB_Rw" title="horemowGh radio"/>

                 <div className="participants">
                    <div className="helperarrow">
                        <HbrArrowLeft width={"2em"} height={"2em"} fillColour={"white"} handleClick={()=>disConnectRadio()}/>
                    </div>
                 
                   <h4 style={{color:"white"}}>{memoizedRadioUsers && memoizedRadioUsers.length} Listening</h4>
                   {/* <h4 style={{color:"white"}}>{memoizedViewers.length} Viewing</h4> */}
                </div>
 
                  <div className="host-info">
                   <div className="live-indicator">
                   <img src={mic} alt="On Air"/> <br/><br/>
                        {/* {hostInfo && 
                            hostInfo.map(hostInfo =>(
                              <div key={hostInfo.timestamp}>
                                  <h2>On Air {hostInfo.adminName}</h2> <br/><br/>
                              </div>
                            ))
                        } */}
                   </div>
                   {/* {hostInfo && 
                      hostInfo.map(hostInfo =>(
                        <div className="host-name" key={hostInfo.timestamp}>
                        <h2>HOST SPEAKER:</h2>  <br/>
                        <h3>{hostInfo.adminName}</h3>  <br/><br/>
                        <h2>Guest/s:</h2>  <br/>
                        <h3>{hostInfo.guests}</h3>  <br/><br/>
                        <h2>Contact:</h2>  <br/>
                        <h3>{hostInfo.adminEmail}</h3>  <br/><br/>
                        <h2>LOCATION:</h2> <br/>
                        <h3>{hostInfo.adminLocation}</h3> <br/>
                      </div>
                      ))
                   } */}
        
                  </div>
             </div>
             
             <img id="horemowGh" src={logo} alt="horemowGh multimedia"/>

             <div className={`commentview-radio  ${width <= 1110 ? 'mobile' : 'desktop'} flex-column1`}>
                    <div className="commentviewtop flex-spacearound" style={{width:"100%", height:"10%"}}>
                        <h4>Share</h4>
                        <HbrShareIcon width={"2em"} height={"2em"} handleClick={()=>setShowShare(true)}/>
                    </div>

                    <CommentCollection programID={programTitle}/>
                    <InputComments userName={userName} programID={programTitle}/>
              </div>

                {showShare && 
                    <ShareForm
                    callToAction={"Join our online radio program on Horemow Gh web"}
                    formTitle={"share to connect friends, families and loved ones"}
                    title={"Horemow Gh online radio"}
                    url={`${appVariables.APP_URL}/onlineradio`}
                    closeForm={()=>setShowShare(false)}
                    showMoreOptions={true}
                    />
                }

             {/* <button id="openHostMobile" onClick={()=>setShowHost(true)}>Host Info</button>
              {
                showHostMobile&&
                <div className="host-info2">
                  <Button onClick={()=>setShowHost(false)}>Close</Button>

                  <div className="live-indicator">
                        <img src={mic} alt="On Air"/> <br/><br/>
                        {hostInfo && 
                            hostInfo.map(hostInfo =>(
                              <div key={hostInfo.timestamp}>
                                  <h2>On Air {hostInfo.adminName}</h2> <br/><br/>
                              </div>
                            ))
                        }
                  </div>

                  {hostInfo && 
                      hostInfo.map(hostInfo =>(
                        <div className="host-name" key={hostInfo.timestamp}>
                        <h2>HOST SPEAKER:</h2>  <br/>
                        <h3>{hostInfo.adminName}</h3>  <br/><br/>
                        <h2>Guest/s:</h2>  <br/>
                        <h3>{hostInfo.guests}</h3>  <br/><br/>
                        <h2>Contact:</h2>  <br/>
                        <h3>{hostInfo.adminEmail}</h3>  <br/><br/>
                        <h2>LOCATION:</h2> <br/>
                        <h3>{hostInfo.adminLocation}</h3> <br/>
                      </div>
                      ))
                  }
    
                </div>
              } */}
          
         </div>
      
      ):(
        <div className="feed-holder">
          <div className="radio-name">
            <h2>HoremowGh Online Radio</h2>
            </div>

            {isLoading && 
               <div style={{
                position:"absolute",
                top:"50%",
                left:"45%",
                width:"50px",
                height:"50px",
                border: "5px solid white",
                borderTop: "5px solid blue",
                borderRadius: "50%",
                animation: "spin2 2s linear infinite",
                }}>
            </div>
          }
       
          <div className="user-info">
            <form onSubmit={handleSubmit}>
            <fieldset>
                      <legend>Mobile number or email</legend>
                      <input type="text" value={user_id} placeholder="mobile number or email" required onChange={(e) =>setUserID(e.target.value.trim())}/>
                  </fieldset>

                  <fieldset>
                      <legend>username</legend>
                      <input type="text" value={name} placeholder="your name" required onChange={(e) =>setName(e.target.value.trim())} />
                  </fieldset>

                  <fieldset>
                      <legend>Location</legend>
                      <input type="text" value={unitLocation} placeholder="your location" required onChange={(e) =>setUnitLocation(e.target.value.trim())}/>
                  </fieldset>
              <button>Proceed to Listen</button>
            </form>
          </div>
        </div>
     
      )
}
export default OnlineRadio;